module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_89_3_3.daad5146.png";